import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { restaurantScopedStorage } from '@/shared/store/restaurantScopedStorage'
import { REVIEW_INVITE_SCHEMA_VERSION } from '../config'
import { ReviewInvite } from '../types/feedback.model'

interface ReviewInviteState extends ReviewInvite {
  setIsActive: (value: boolean) => void
  /** Replaces the whole document, for when the API starts hydrating this. */
  importInvite: (invite: ReviewInvite) => void
}

export const useReviewInviteStore = create<ReviewInviteState>()(
  persist(
    set => ({
      /*
        On from the start, so a new venue is collecting rather than having to
        find a switch first. Being on without a Google place connected is not
        a silent failure: the page says plainly that no guest gets a link yet.
      */
      isActive: true,

      setIsActive: value => set({ isActive: value }),

      importInvite: invite => set({ isActive: invite.isActive })
    }),
    {
      name: 'review-invite-storage',
      storage: createJSONStorage(() => restaurantScopedStorage),
      version: REVIEW_INVITE_SCHEMA_VERSION,
      partialize: state => ({ isActive: state.isActive }),
      /*
        Every older version kept `rules` beside the switch: a star threshold
        and, from v2, the place picked out of Google's suggestions. Both are
        gone (see the version note in config.ts); the switch stays.
      */
      migrate: persisted => {
        const state = persisted as Partial<ReviewInvite> | undefined
        return { isActive: state?.isActive ?? true } as ReviewInviteState
      }
    }
  )
)
